import { useState, useEffect } from "react";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import SelectCustom from "../../../component/elements/selectCustom";
import { validateForm } from "../../../utils/formValidation/validation";
import { inventoryValidationRules } from "../../../utils/formValidation/validationRules";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { useSelector } from "react-redux";
import ImageUploader from "../../../component/imageUploader";
import { categoryOptionsInventory, serviceTypes } from "../../../constants/campaignConstants";
import MultiSelectCustom from "../../../component/elements/multiSelectCustom";



function InventoryForm({ onClose, onSubmit, dialogDetails, mode }) {
  const [formData, setFormData] = useState({
    name: "",
    sku: "",
    description: "",
    quantity: "",
    price: "",
    category: "",
    applicableCategory: [],
    imageUrl: null,
  });

  const [formErrors, setFormErrors] = useState({});
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;

  useEffect(() => {
    if (dialogDetails) {
      setFormData({
        name: dialogDetails?.itemName || dialogDetails?.name || "",
        sku: dialogDetails?.skuCode || dialogDetails?.sku || "",
        description: dialogDetails?.itemDescription || "",
        quantity:
          dialogDetails?.itemQuantity || dialogDetails?.itemQuantity || "",
        price: dialogDetails?.pricePerQuantity || "",
        category: dialogDetails?.category || "",
        applicableCategory: dialogDetails?.applicableCategory || "",
        imageUrl: dialogDetails?.itemImage || null,
      });
    }
  }, [dialogDetails]);

  const handleChange = (field) => (e) => {
    const value = e.target?.value ?? e;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = () => {
    const errors = validateForm(formData, inventoryValidationRules);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const payload = {
        itemName: formData.name,
        skuCode: formData.sku,
        itemDescription: formData.description,
        itemQuantity: Number(formData.quantity),
        pricePerQuantity: Number(formData.price),
        category: formData.category,
        applicableCategory: formData.applicableCategory,
        itemImage: formData.imageUrl,
      };

      const request =
        mode === "create"
          ? axiosInstance.post(
              `/customer/store/inventory/create/${storeId}`,
              payload
            )
          : axiosInstance.patch(
              `/customer/store/inventory/update/${dialogDetails?.id}`,
              payload
            );

      request
        .then(() => {
          onSubmit();
        })
        .catch(() => {
          showSnackbar("Something went wrong!", "error");
        });
    }
  };

  return (
    <div className="py-4 px-6">
      <div className="flex justify-between mb-6">
        <div className="text-lg font-[500]">
          {mode === "create" ? "Add Inventory Item" : "Edit Inventory Item"}
        </div>
        <button
          className="text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="grid  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-1 gap-x-6 mb-1 ">
        <TextFieldCustom
          fullWidth
          label="Item Name*"
          value={formData.name}
          onChange={handleChange("name")}
          error={!!formErrors.name}
          helperText={formErrors.name || " "}
        />
        <TextFieldCustom
          fullWidth
          label="SKU*"
          value={formData.sku}
          onChange={handleChange("sku")}
          error={!!formErrors.sku}
          helperText={formErrors.sku || " "}
        />
        <TextFieldCustom
          fullWidth
          label="Quantity*"
          value={formData.quantity}
          onChange={(e) => {
            const val = e.target.value;
            if (/^\d*$/.test(val)) {
              handleChange("quantity")(e);
            }
          }}
          error={!!formErrors.quantity}
          helperText={formErrors.quantity || " "}
        />
        <TextFieldCustom
          fullWidth
          label="Price Per Quantity*"
          value={formData.price}
          onChange={(e) => {
            const val = e.target.value;
            if (/^\d*\.?\d*$/.test(val)) {
              handleChange("price")(e);
            }
          }}
          error={!!formErrors.price}
          helperText={formErrors.price || " "}
        />
        <SelectCustom
          fullWidth
          label="Category*"
          options={categoryOptionsInventory}
          value={formData.category}
          onChange={handleChange("category")}
          error={!!formErrors.category}
          helperText={formErrors.category || " "}
        />
        <MultiSelectCustom
          fullWidth
          label="Applicable Category*"
          options={serviceTypes}
          value={formData.applicableCategory}
          onChange={handleChange("applicableCategory")}
          error={!!formErrors.applicableCategory}
          helperText={formErrors.applicableCategory || " "}
        />
      </div>

      <TextFieldCustom
        fullWidth
        label="Description (optional)"
        value={formData.description}
        onChange={handleChange("description")}
        error={!!formErrors.description}
        helperText={formErrors.description || " "}
        heightClass="custom-textarea-height"
        multiline
        rows={2}
      />

      <ImageUploader
        value={formData.imageUrl}
        onChange={(fileUrl) =>
          setFormData((prev) => ({ ...prev, imageUrl: fileUrl }))
        }
      />
      <div className="flex flex-col xs:flex-row justify-center items-center mt-8 mb-4 gap-3">
        <CustomButton
          onClick={onClose}
          customeClass="primary-custom-button w-full xs:w-[150px] h-[40px]"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={handleSubmit}
          customeClass="gradient-button w-full xs:w-[150px] h-[40px]"
        >
          Submit
        </CustomButton>
      </div>
    </div>
  );
}

export default InventoryForm;
